import { CheckboxFormField, FormSection, GridContainer, GridItem } from "@duosoftbg/nacid-components";
import React from "react";

const AccountVerificationFormSection = () => {
  return (
    <FormSection label={"t.account.verification.details"}>
      <GridContainer>
        <GridItem>
          <CheckboxFormField fieldName={"enabled"} labelCode={"l.user.enabled"} />
        </GridItem>
        <GridItem>
          <CheckboxFormField fieldName={"emailVerified"} labelCode={"l.user.emailVerified"} />
        </GridItem>
      </GridContainer>
    </FormSection>
  );
};

export default AccountVerificationFormSection;
